import styled from 'styled-components/macro';

const HEADER_HEIGHT = '156px';

const Body = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - ${HEADER_HEIGHT});
`;

export default Body;
